import { Pipe, PipeTransform, Inject, LOCALE_ID, InjectionToken } from '@angular/core';

export const BPM_RUNTIME_DEVKIT_LANG_RESOURCES_TOKEN = new InjectionToken<any>('BPM_RUNTIME_DEVKIT_LANG_RESOURCES');

@Pipe({ name: 'locale' })
export class LocalePipe implements PipeTransform {
  private readonly defaultLang: string = "zh-CHS";
  private langCode: string;
  private lang: {};
  private resources;
  constructor(
    @Inject(LOCALE_ID) localeId: string,
    @Inject(BPM_RUNTIME_DEVKIT_LANG_RESOURCES_TOKEN) resources: any,
  ) {
    this.langCode = localeId || "zh-CHS";
    this.lang = resources[this.langCode] || resources[this.defaultLang] || {};
  }
  transform(name: string): any {
    return this.lang[name] || name;
  }
  instant(name: string) {
    return this.transform(name);
  }
}

